import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationDropdownComponent } from './translation-dropdown.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [TranslationDropdownComponent],
  imports: [
    CommonModule,
    FormsModule,
    BsDropdownModule.forRoot(),
  ],
  exports:[
    TranslationDropdownComponent,
    CommonModule,
    FormsModule,
    BsDropdownModule,
  ],
})
export class TranslationDropdownModule { }
